import React, { Component } from 'react';
import './cigerate.css';
import Navbar from '../layouts/navbar';
import { HashLink } from 'react-router-hash-link';


class Ameth extends Component {
    componentDidMount(){
        window.scrollTo(0,0);
    }
    render() {
        return (
            <div>
                <Navbar head="Amphetamines" />
                <div className="container" style={{marginTop:"60px"}}>
                    <HashLink to='/faq#ameth'>
                        <button id="myBtn" title="FAQ">
                            <i class="fas fa-info-circle faqicon"></i>
                            <p>  FAQ</p>
                        </button>
                    </HashLink>

                    <div className="row justify-content-center">
                        <div className="col-12 text-center ">
                        <img className="img-fluid" src="/assests/images/educationAmphetamine.png" alt="Amphetamine">
                        </img>
                        
                        </div>
                    </div>

                    <div className="content">
                        <h2>Amphetamines</h2>
                        <p>Amphetamines, like Ritalin, Adderall, and Dexedrine, are <b>prescription drugs used to treat ADHD and narcolepsy</b>. It is accessible through misuse, or overuse of prescriptions. India lists these substances as Schedule X drugs, as such, they are not easily available.
                        </p>

                        <h4>
                            Short term effects include
                        </h4>
                        <ul style={{fontSize:"large"}}>
                            <li>Dilated pupils</li>
                            <li>Restlessness and hyperactivity</li>
                            <li>Loss of appetite</li>
                            <li>Sweating</li>
                            <li>Overusing prescriptions</li>
                            <li>Aggression outbursts and mood swings</li>
                            <li>Impulsivity</li>
                            <li>Hyper focus</li>
                            <li>Increased blood pressure and heart rate</li>
                            <li>Increased blood sugar, blood flow, and body temperature</li>
                            <li>Nausea, vomiting, diarrhea, and abdominal cramps</li>
                        </ul>

                        <h4>
                            Long term effects include
                        </h4>
                        <ul style={{fontSize:"large"}}>
                            <li>Nausea, vomiting, diarrhea, and abdominal cramps</li>
                            <li>Malnutrition or weight loss</li>
                            <li>Psychosis</li>
                            <li>Damage to blood vessels</li>
                            <li>Kidney and lung damage</li>
                            <li>Stroke</li>

                        </ul>
                    </div>
                </div>
            </div>
        )
    }
}

export default Ameth;